import React from 'react';
import SingleInterest from "./singleInterest";

const NewsletterSubscriptionInterests = ({resourcedTexts, interests, setInterests, handleInterestsSubmit, eventCodeInterests}) => {
    const renderInterests = () => {
        if (interests.length) {
            return interests.map((singleInterest, i) => {
                return (
                    <SingleInterest
                        setInterests={setInterests}
                        singleInterest={singleInterest}
                        eventCodeInterests={eventCodeInterests}
                        key={i}
                    />
                )
            })
        }
    }

    return (
        <div className="newsletter-subscription__panel">
            <h3 className="newsletter-subscription__title">{resourcedTexts.interestsTitle}</h3>
            <p>{resourcedTexts.interestsText}</p>

            <ul className="interests-list">
                {renderInterests()}
            </ul>

            <button onClick={handleInterestsSubmit}>{resourcedTexts.interestsButtonText}</button>
        </div>
    )
}

export default NewsletterSubscriptionInterests;